var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#43B02A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.30474 14.1357H22.3618C22.6786 14.1357 22.9355 14.4481 22.9355 14.8335C22.9355 15.2188 22.6786 15.5312 22.3618 15.5312H9.30474C8.98783 15.5312 8.73096 15.2188 8.73096 14.8335C8.73096 14.4481 8.98783 14.1357 9.30474 14.1357Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5503 14.8333L17.0597 9.37271C16.8356 9.10023 16.8356 8.65846 17.0597 8.38598C17.2837 8.11353 17.647 8.11353 17.8711 8.38598L22.7675 14.3399C22.9916 14.6124 22.9916 15.0542 22.7675 15.3267L17.8711 21.2806C17.7591 21.4169 17.6122 21.485 17.4654 21.485C17.3185 21.485 17.1717 21.4169 17.0596 21.2806C16.8355 21.0081 16.8355 20.5664 17.0596 20.2939L21.5503 14.8333Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessage);
export default __webpack_public_path__ + "static/media/sendMessage.0e3b8aaac4542909f94fe54c43eccb36.svg";
export { ForwardRef as ReactComponent };